import { useCallback, useMemo, useState } from "react";
import { inspectionsAPI } from "../../../../../services/api";

export const useInspectionActions = ({ projectId, openId, reload, openBundle }) => {
const [loading, setLoading] = useState({
submit: false,
approve: false,
reject: false,
reopen: false,
saveSummary: false,
addFinding: false,
completeChecklist: false,
uploadPhoto: false,
saveChecklistDraft: false,
});

const setL = (k, v) => setLoading((p) => ({ ...p, [k]: v }));

const refresh = useCallback(async () => {
await reload?.();
if (openId) await openBundle(openId);
}, [reload, openId, openBundle]);

const submit = useCallback(async () => {
if (!projectId || !openId) return;
setL("submit", true);
try {
    await inspectionsAPI.submit(projectId, openId);
    await refresh();
} finally {
    setL("submit", false);
}
}, [projectId, openId, refresh]);

const approve = useCallback(async () => {
if (!projectId || !openId) return;
setL("approve", true);
try {
    await inspectionsAPI.approve(projectId, openId);
    await refresh();
} finally {
    setL("approve", false);
}
}, [projectId, openId, refresh]);

const reopen = useCallback(async () => {
if (!projectId || !openId) return;
setL("reopen", true);
try {
    await inspectionsAPI.reopen(projectId, openId);
    await refresh();
} finally {
    setL("reopen", false);
}
}, [projectId, openId, refresh]);

const rejectPrompt = useCallback(
async (inspectionId) => {
    if (!projectId || !inspectionId) return;
    const note = window.prompt("Rejection reason (required):");
    if (!note || !note.trim()) return;

    setL("reject", true);
    try {
    await inspectionsAPI.reject(projectId, inspectionId, { rejection_note: note.trim() });
    if (inspectionId === openId) await refresh();
    else await reload?.();
    } finally {
    setL("reject", false);
    }
},
[projectId, openId, refresh, reload]
);

const busy = useMemo(() => Object.values(loading).some(Boolean), [loading]);

return {
loading,
busy,

submit,
approve,
rejectPrompt,
reopen,

setL,
};
};
